import { useState } from "react";
import SectionSetting from "components/common/SectionSetting";
import EventLogTable from "./EventLogTable";

const EventLog = (props) => {
  const { wellId, assetId, loadingIconActions } = props;
  // AV-D5: replaced the "All Members / Locations / Revenue / Join Date"
  // scaffold dropdown with a functional event search box.
  const [search, setSearch] = useState("");

  return (
    <div className="cards-container h-100">
      <div className="cards-header d-flex flex-row justify-content-between align-items-center">
        <span className="header-title">Event Log</span>
        <div className="header-menu-container d-flex flex-row align-items-center">
          <div className="form-container me-2">
            <form
              className="app-search d-none d-lg-block"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="d-flex flex-row">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search well / event / status..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <div className="search-icon">
                  <i className="bi bi-search"></i>
                </div>
              </div>
            </form>
          </div>
          <div className="cards-setting-btn">
            <SectionSetting disable />
          </div>
        </div>
      </div>

      <div className="cards-content">
        <div className="table-container overflow-auto hide-scrollbar">
          <EventLogTable
            wellId={wellId}
            assetId={assetId}
            loadingIconActions={loadingIconActions}
            search={search}
          />
        </div>
      </div>
    </div>
  );
};

export default EventLog;
